export const Alabama = "Alabama";
export const Alaska = "Alaska";
export const Arizona = "Arizona";
export const Arkansas = "Arkansas";
export const California = "California";
export const Colorado = "Colorado";
export const Connecticut = "Connecticut";
export const Delaware = "Delaware";
export const Florida = "Florida";
export const Georgia = "Georgia";
export const Hawaii = "Hawaii";
export const Idaho = "Idaho";
export const Illinois = "Illinois";
export const Indiana = "Indiana";
export const Iowa = "Iowa";
export const Kansas = "Kansas";
export const Kentucky = "Kentucky";
export const Louisiana = "Louisiana";
export const Maine = "Maine";
export const Maryland = "Maryland";
export const Massachusetts = "Massachusetts";
export const Michigan = "Michigan";
export const Minnesota = "Minnesota";
export const Mississippi = "Mississippi";
export const Missouri = "Missouri";
export const Montana = "Montana";
export const Nebraska = "Nebraska";
export const Nevada = "Nevada";
export const NewHampshire = "NewHampshire";
export const NewJersey = "NewJersey";
export const NewMexico = "NewMexico";
export const NewYork = "NewYork";
export const NorthCarolina = "NorthCarolina";
export const NorthDakota = "NorthDakota";
export const Ohio = "Ohio";
export const Oklahoma = "Oklahoma";
export const Oregon = "Oregon";
export const Pennsylvania = "Pennsylvania";
export const RhodeIsland = "RhodeIsland";
export const SouthCarolina = "SouthCarolina";
export const SouthDakota = "SouthDakota";
export const Tennessee = "Tennessee";
export const Texas = "Texas";
export const Utah = "Utah";
export const Vermont = "Vermont";
export const Virginia = "Virginia";
export const Washington = "Washington";
export const WestVirginia = "WestVirginia";
export const Wisconsin = "Wisconsin";
export const Wyoming = "Wyoming";
export type CommonWealthState = "Alabama" | "Alaska" | "Arizona" | "Arkansas" | "California" | "Colorado" | "Connecticut" | "Delaware" | "Florida" | "Georgia" | "Hawaii" | "Idaho" | "Illinois" | "Indiana" | "Iowa" | "Kansas" | "Kentucky" | "Louisiana" | "Maine" | "Maryland" | "Massachusetts" | "Michigan" | "Minnesota" | "Mississippi" | "Missouri" | "Montana" | "Nebraska" | "Nevada" | "NewHampshire" | "NewJersey" | "NewMexico" | "NewYork" | "NorthCarolina" | "NorthDakota" | "Ohio" | "Oklahoma" | "Oregon" | "Pennsylvania" | "RhodeIsland" | "SouthCarolina" | "SouthDakota" | "Tennessee" | "Texas" | "Utah" | "Vermont" | "Virginia" | "Washington" | "WestVirginia" | "Wisconsin" | "Wyoming";
export const CommonWealthStateListing:CommonWealthState[] = ["Alabama" , "Alaska" , "Arizona" , "Arkansas" , "California" , "Colorado" , "Connecticut" , "Delaware" , "Florida" , "Georgia" , "Hawaii" , "Idaho" , "Illinois" , "Indiana" , "Iowa" , "Kansas" , "Kentucky" , "Louisiana" , "Maine" , "Maryland" , "Massachusetts" , "Michigan" , "Minnesota" , "Mississippi" , "Missouri" , "Montana" , "Nebraska" , "Nevada" , "NewHampshire" , "NewJersey" , "NewMexico" , "NewYork" , "NorthCarolina" , "NorthDakota" , "Ohio" , "Oklahoma" , "Oregon" , "Pennsylvania" , "RhodeIsland" , "SouthCarolina" , "SouthDakota" , "Tennessee" , "Texas" , "Utah" , "Vermont" , "Virginia" , "Washington" , "WestVirginia" , "Wisconsin" , "Wyoming"];
